import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-cameras-list',
    templateUrl: './cameras-list.component.html',
    styleUrls: ['./cameras-list.component.css']
})
export class CamerasListComponent implements OnInit {

    key: string;

    constructor(private activatedRoute: ActivatedRoute, private titleService: Title) {
        titleService.setTitle('Wissle Cameras Modal');
     }

    ngOnInit() {
        this.activatedRoute.params
			.subscribe(params => {
				this.key = params.key;
			});
    }

}
 